
import { Settings } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ProfileDialog } from "@/components/ProfileDialog";
import { SubscriptionDialog } from "@/components/SubscriptionDialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { SettingsMenuItems } from "@/components/settings/SettingsMenuItems";
import { useProfileSettings } from "@/hooks/useProfileSettings";

export function SettingsButton() {
  const {
    showProfileDialog,
    setShowProfileDialog,
    showSubscriptionDialog,
    setShowSubscriptionDialog,
    profileData,
    handleSettingsClick,
    handleSignOut,
  } = useProfileSettings();

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="outline"
            size="icon"
            className="fixed top-4 right-4 z-50 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 bg-card border-muted/30"
          >
            <Settings className="h-5 w-5" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-48">
          <SettingsMenuItems
            onProfileClick={handleSettingsClick}
            onSubscriptionClick={() => setShowSubscriptionDialog(true)}
            onSignOut={handleSignOut}
          />
        </DropdownMenuContent>
      </DropdownMenu>

      <ProfileDialog
        open={showProfileDialog}
        onOpenChange={setShowProfileDialog}
        initialData={profileData}
      />

      <SubscriptionDialog
        open={showSubscriptionDialog}
        onOpenChange={setShowSubscriptionDialog}
        mode="manage"
      />
    </>
  );
}
